<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <span class="wy-page-tooltip">
    <el-tooltip v-if="currentPageInfo.tooltip" effect="dark" popper-class="wy-page-tooltip-popup" placement="bottom">
      <div slot="content"><span v-html="$t(currentPageInfo.tooltip)"></span></div>
      <img class="info-icon" src="../../assets/icons/icon_info.svg">
    </el-tooltip>
  </span>
</template>

<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';

export default Vue.extend({
  name: 'wy-page-nodata',

  computed: {
    ...mapGetters(['currentPageInfo']),
  }
});
</script>

<style lang="scss">
.wy-page-tooltip {
  .info-icon {
    margin-top: 2px;
    width: 17px;
    position: relative;
    top: 0px;
  }
}

.wy-page-tooltip-popup {
  max-width: 400px;
}
</style>